import { render, staticRenderFns } from "./StudentPerformanceList.vue?vue&type=template&id=2e640358&scoped=true"
import script from "./StudentPerformanceList.vue?vue&type=script&lang=js"
export * from "./StudentPerformanceList.vue?vue&type=script&lang=js"
import style0 from "./StudentPerformanceList.vue?vue&type=style&index=0&id=2e640358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e640358",
  null
  
)

export default component.exports